import $ from 'jquery';
// Initialize and add the map
function initMap() {
  const PLUGIN = 'is_contactboxMap';
  const MAP_STYLES = [
    {
      featureType: 'all',
      elementType: 'geometry.fill',
      stylers: [
        {
          weight: '2.00',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#9c9c9c',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f2f2f2',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#eeeeee',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#7b7b7b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#46bcec',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#c8d7d4',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#070707',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
  ];

  const svgMarker = {
    path: 'M26.5858 11.3137L28 9.9L18 0L16.6858 1.415L17.8716 2.6007L6.38 12.3225L4.6641 10.6067L3.25 12L8.9072 17.6773L0 26.5831L1.41 28L10.3211 19.0913L16 24.7482L17.3929 23.3342L15.6765 21.618L25.4005 10.1285L26.5858 11.3137Z',
    fillColor: '#E30613',
    fillOpacity: 1,
    strokeWeight: 0,
    rotation: 0,
    scale: 1,
    anchor: new google.maps.Point(0, 28),
  };

  const Map = function (el, options) {

    this.el = el;
    this.options = options;

    const pos = { lat: parseFloat(options.latitude), lng: parseFloat(options.longitude) };

    this.map = new google.maps.Map(el, {
      zoom: 14,
      center: pos,
    });

    this.map.mapTypes.set('scm', new google.maps.StyledMapType(MAP_STYLES, { name: 'SCM' }));
    this.map.setMapTypeId('scm');

    const marker = new google.maps.Marker({
      position: pos,
      map: this.map,
      icon: svgMarker,
      url: `https://maps.google.com/?q=${options.latitude},${options.longitude}`,
    });

    marker.addListener('click', () => {
      window.open(marker.url, '_blank').focus();
    });
  };

  $.fn[PLUGIN] = function (options) {
    this.each(function () {
      if (!$.data(this, `plugin_${PLUGIN}`)) {
        var options = $.extend({}, options, $(this).data('contactbox'));
        $.data(this, `plugin_${PLUGIN}`, new Map(this, options));
      }
    });
    return this;
  };

  $('[data-contactbox]')[PLUGIN]();
}

window.initMap = initMap;
